const licensesResources = {
  en: {
    licenses: {
      title: 'Licenses',
      text: '"In accordance with paragraph 2 of Article 22 of the Law of the Republic of Kazakhstan "On Insurance Activity", the official status of an insurance (reinsurance) organization is determined by the state registration of a legal entity as an insurance (reinsurance) organization in the judicial authorities and the availability of a license of the authorized body for the right to carry out insurance activity."',
    },
  },
  kz: {
    licenses: {
      title: 'Лицензиялар',
      text: '«Сақтандыру қызметі туралы» Қазақстан Республикасы Заңының 22-бабының 2-тармағына сәйкес сақтандыру (қайта сақтандыру) ұйымының ресми мәртебесі заңды тұлғаны әділет органдарында сақтандыру (қайта сақтандыру) ұйымы ретінде мемлекеттік тіркеумен және сақтандыру қызметін жүзеге асыру құқығына уәкілетті органның лицензиясының болуымен айқындалады».',
    },
  },
  ru: {
    licenses: {
      title: 'Лицензии',
      text: '«В соответствии с пунктом 2 статьи 22 Закона Республики Казахстан «О страховой деятельности» официальный статус страховой (перестраховочной) организации определяется государственной регистрацией юридического лица в качестве страховой (перестраховочной) организации в органах юстиции и наличием лицензии уполномоченного органа на право осуществления страховой деятельности».',
    },
  },
};

export default licensesResources;
